<template>

    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="项目评审名称" name="projectReviewName">
                <a-input v-model:value="searchForm.projectReviewName" placeholder="请输入项目评审名称"/>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>
        <a-alert message="需完善资料的必须3个工作日内进行上传提交" type="warning" show-icon style="margin-bottom: 8px" />
        <a-table :columns="columns" :row-selection="null"
                 :pagination="pagination" :data-source="dataSource" :loading="loading" @change="onTableChange">
            <template #projectReviewName="{ record,text }">
                <a @click="showDetail(record)" href="javascript:;" :title="text" >{{ text }}</a>
            </template>
            <template #meetingMinutes="{ record }">
                <span v-if="'6,0'.includes(record.reviewStatus)">无需审核</span>
                <span v-else>
                    <span :class="record.hasDeny?'red':''">{{ record.confirmCount }}</span>/{{ record.reviewExpertCount || 0 }}
                </span>
            </template>
            <template #reviewStatus="{record, text }">
                <div style="cursor: pointer" @click="showProcessPanel(record)">
                    <ReviewStatus :status="text"></ReviewStatus>
                </div>
            </template>

            <template #reviewResult="{ record }">
                <img style="cursor: pointer" v-if="record.reviewResultAttachment" @click="onPreviewFile(record.reviewResultAttachment)" src="@/assets/img/psjg.png"/>
                <div v-else>无</div>
<!--                <FileUpload v-model:value="record.reviewResultAttachment" :show-btn="false" disabled></FileUpload>-->
            </template>
            <template #appendFile="{ record }">
                <FileUpload v-if="record.reviewStatus==='5'" v-model:value="append.fileList" :names="'资料上传'" :multiple="true" :size="50" :count="5" :isPdfImg="true"></FileUpload>
                <FileUpload v-else v-model:value="record.appendFile" :disabled="true" :show-btn="false" :multiple="true" :size="50" :count="5" :isPdfImg="true"></FileUpload>
            </template>
            <template #action="{ record }">
<!--                <div class="table-row-operations">-->
<!--                    <a v-if="record.reviewStatus==='5'" @click="onView(record)">评审意见</a>-->
<!--                    <a v-if="record.reviewStatus==='7'" @click="onView(record)">确认意见</a>-->
<!--                    <a v-if="record.reviewStatus==='7'" @click="onView(record)">确认意见</a>-->
<!--                </div>-->
<!--                <div class="table-row-operations">
                    <a @click="onDownload(record)">下载</a>
                </div>-->
                <div class="table-row-operations">
                    <a-popconfirm
                        v-if="record.reviewStatus!=='0'"
                        title="在此基础创建新的评审?"
                        ok-text="是"
                        cancel-text="否"
                        @confirm="onCreateNext(record)"
                        @cancel="()=>{}"
                    >
                        <a>再审</a>
                    </a-popconfirm>
                </div>
                <div v-if="record.reviewStatus==='6' && record.reviewType!=='0' && !record.noCheckAppendFile" class="table-row-operations">
                    <a @click="showNoCheckAppendModal(record)">上传资料</a>
                </div>
                <div v-if="record.reviewStatus==='5'" class="table-row-operations">
                    <a @click="showAppendModal(record)">完善材料</a>
                </div>
            </template>
        </a-table>
    </a-card>
    <AddOrEditModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
    <a-modal v-model:visible="resultAudit.visible" centered title="专家评审意见" :footer="null" @ok="handleOk">
        <p>{{ resultAudit.reviewResultAdvise }}</p>
    </a-modal>

    <a-modal v-model:visible="expertAdvise.visible2" centered :title="(expertAdvise.adviseList.length!==0?'专家评审':'审核')+'意见'" :footer="null" @ok="handleOk">
        <p v-for="(item, index) in expertAdvise.adviseList" :key="index">专家{{index+1}}: {{ item.auditAdvise }}</p>
        <p v-if="expertAdvise.adviseList.length===0">{{resultAudit.reviewResultAdvise}}</p>
    </a-modal>
    <detail ref="detail"></detail>
    <ProcessPanel ref="panel"></ProcessPanel>
    <ImproveData ref="improve" @finish="loadData"></ImproveData>
    <no-check-append-file-modal ref="noCheck" @finish="loadData"/>
</template>

<script>

import {dictMixin, tableListMixin} from "@/mixins";

import {application, confirm} from "@/api/projectReviewService";
import AddOrEditModal from "./components/AddOrEditModal";
import FileUpload from "@/components/form/upload/FileUpload";
// import axios from "axios";
import {file_service} from "@/api/adminService";
import Detail from "@/views/sys/application/info/components/Detail";
import ProcessPanel from "@/views/sys/application/resultAudit/components/ProcessPanel";
import ImproveData from "@/views/sys/application/resultAudit/components/ImproveData";
import ReviewStatus from "@/views/sys/expert/registered/components/ReviewStatus";
import NoCheckAppendFileModal from "@/views/sys/application/resultAudit/components/NoCheckAppendFileModal.vue";
import reviewStatus from "@/views/sys/expert/registered/components/ReviewStatus.vue";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {
        title: "评审名称",
        dataIndex: "projectReviewName",
        key: "projectReviewName",
        width: "300px",
        slots: {customRender: "projectReviewName"}
    },
    {title: "评审时间", width: "150px", dataIndex: "reviewTime", key: "reviewTime"},
    {title: "评审状态",  width: "120px", dataIndex: "reviewStatus", key: "reviewStatus", slots: {customRender: "reviewStatus"}},
    // {title: "完善材料", dataIndex: "appendFile", key: "appendFile", ellipsis: true, slots: {customRender: "appendFile"}},
    {title: "专家审核", dataIndex: "meetingMinutes", key: "meetingMinutes", slots: {customRender: "meetingMinutes"}},
    {title: "评审结果",align:"center", width:"100px",dataIndex: "reviewResult", key: "reviewResult", slots: {customRender: "reviewResult"}},
    {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
    name: "index",
    computed: {
        reviewStatus() {
            return reviewStatus
        }
    },
    mixins: [tableListMixin, dictMixin],
    components: {
        NoCheckAppendFileModal,
        ImproveData,
        ProcessPanel,
        FileUpload,
        AddOrEditModal,
        Detail,
        ReviewStatus
    },
    data() {
        return {
            expertAdvise:{
                visible2:false,
                adviseList:[]
            },
            resultAudit:{
                visible:false,
                reviewResultAdvise:''
            },
            append:{
                fileList:''
            },
            columns,
            queryParamFixed:{reviewStatus: '-1,0,5,6,7'},
            queryParam: {},
            listUrl: application.myPageList,
            listKeyField: "id",
            deleteUrl: application.delete
        }
    },
    methods: {
        onCreateNext(record){
            this.onShowModal('modal',{projectReviewName:record.projectReviewName+'-再审', preReviewId: record.id});
        },
        showNoCheckAppendModal(row){
            let data = {...row}
            const noCheck = this.$refs['noCheck'];
            noCheck.visible = true
            noCheck.reviewId = data.id
        },
        showAppendModal(row){
            let data = {...row}
            const refEle = this.$refs['improve'];
            refEle.reviewId = data.id
            refEle.reviewStatus = data.reviewStatus
            refEle.reviewResultAdvise = data.reviewResultAdvise
            refEle.visible = true
        },
        showProcessPanel(row){
            if(row.reviewStatus==='-1'){
                return
            }
            let data = {...row}

            const refEle = this.$refs['panel'];
            refEle.reviewId = data.id
            refEle.reviewStatus = data.reviewStatus
            refEle.visible = true
        },
        truncateText(text, maxLength) {
            // 定义一个最大字符数限制
            if (text && text.length > maxLength) {
                return text.substring(0, maxLength) + '...';
            }
            return text;
        },
        showDetail(row){
            let rows = {...row}
            this.onShowModal("detail", rows)
        },
        visibleChange(visible, record){
            if (visible){
                this.getAction({
                    url: confirm.list,
                    params:{
                        applicationId:record.id
                    }
                }).then(resp=>{
                    this.expertAdvise.adviseList = resp
                    this.resultAudit.reviewResultAdvise = record.reviewResultAdvise
                })
            }

        },
        onView(record) {
            this.expertAdvise.visible2 = true
            this.getAction({
                url: confirm.list,
                params:{
                    applicationId:record.id
                }
            }).then(resp=>{
                this.expertAdvise.adviseList = resp
            })
        },
        onDownload( record ){
            let attachment = record.reviewResultAttachment;
            let files = attachment.split(",");
            files.forEach(item=>{
                let fileId = item;
                const link = document.createElement("a"); // 创建a标签
                link.href = file_service.download + fileId;
                link.target = '_blank';
                link.click();
            })

        },
        onSubmit(record) {
            if (!this.append.fileList){
                this.$message.warning("请先上传需要完善的文件")
                return
            }
            this.postAction({
                url: application.appendAudit,
                params: {
                    applicationId: record.id,
                    files: this.append.fileList
                }
            }).then(() => {
                this.loadData(this.pagination.current)
            })
        },

    }
}
</script>

<style scoped>
:deep(.ant-upload-list-item){
    margin-top: 0;
}
</style>
